// fejlesztés-típus badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `productUpdateType`
// fogalom): feature → violet (új dolog) · improvement → brand (jobb lett) · fix → danger (hiba volt) ·
// security → warning (kockázat) · performance → secondary (mérhető, de nem drámai), mindegyik vezető
// ikonnal. ez a fájl csak a kényelmes, névre szóló API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface ProductUpdateTypeBadgeProps {
  /** A nyers típus-string (a jel forrása). */
  type: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('productUpdates.type.…')`-ból. */
  label: string;
  className?: string;
}

export function ProductUpdateTypeBadge({
  type,
  label,
  className,
}: ProductUpdateTypeBadgeProps): JSX.Element {
  return <DomainBadge kind="productUpdateType" value={type} label={label} className={className} />;
}
